import { Box, Button, Typography } from "@mui/material";
import {  BossSouls,  UsefullEnnemySoul } from "./EnnemySoulData";
import Item from "../../core/items/Item";
import { useNavigate } from "react-router-dom";
import { isNil, orderBy } from "lodash";
import { DragEvent, useState } from "react";
import { SimpleKokiriEmeraldItem } from "../inventory/medallions/KokiriEmeraldItem";
import { SimpleGoronRubyItem } from "../inventory/medallions/GoronRubyItem";
import { SimpleZoraSapphireItem } from "../inventory/medallions/ZoraSapphireItem";
import { SimpleForestMedallionItem } from "../inventory/medallions/ForestMedallionItem";
import { SimpleFireMedallionItem } from "../inventory/medallions/FireMedallionItem";
import { SimpleWaterMedallionItem } from "../inventory/medallions/WaterMedallionItem";
import { SimpleShadowMedallionItem } from "../inventory/medallions/ShadowMedallionItem";
import { SimpleSpiritMedallionItem } from "../inventory/medallions/SpiritMedallionItem";
import { OotItemDto } from "../hints/OotItemAutocomplete";

export enum RegionSoulEnum {
    Deku,
    DC,
    Jabu,
    Forest,
    Fire,
    Water,
    Shadow,
    Spirit,
    Ganon,
    Botw,
    Ice,
    Gtg,
    SFM,
    Grottos
}

export interface EnnemyDto {
    name: string,
    img: string,
    isObtained?: boolean,
    checks?: Array<string> 
    dungeonsMandatory?: Array<string>,
    type: "boss" | "monster",
    order?: number
}

const EnnemyTracker = () => {

    let navigate = useNavigate();
    return<Box display="flex" flexDirection={"row"}> 
    <Box display="flex" flexWrap={"wrap"} justifyContent={"space-around"}>
        <SoulTracker track="all"/>
    </Box>
    <Box display="flex" flexDirection={"column"}>
        <Button onClick={()=> navigate("/ootr/tracker/ennemy/vertical") } >Vertical Layout</Button>
        <Button onClick={()=> navigate("/ootr/tracker/ennemy/horizontal") }>Horizontal Layout</Button>
    </Box>
     
 </Box>


}
export default EnnemyTracker;


export const BossSoulTracker = () => {

    return  <Box display="flex" width="600px" flexDirection={"column"}>
   
        <Box display="flex" justifyContent={"center"} fontSize={20}>Boss Soul Tracker</Box>
 
    <Box display="flex" flexWrap={"wrap"} width="600px" justifyContent={"center"} alignItems={"flex-start"}>
     {BossSouls.map((e) => {
         return <Box display="flex" margin="5px">
             <Item id={e.name} image={e.img} title={e.name} displayName imageComponent={(props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>)=> <img {...props} src={e.img} alt={e.name} height={100} width={100}/>}  />
         </Box>
     })}

 </Box>
 </Box>
}


interface MinorEnnemyTrackerProps {
    imgSize?: number,
    fontSize?: number,
    displayDungeonData?: true
    displayLabel?: boolean
    track?: "boss" | "all" | "regional",
    regionalEnnemies?: Array<RegionalSoulObjectProps>
    ennemies?: Array<EnnemyDto>
    setRegionalEnnemy?: (r: RegionSoulEnum,e: RegionalSoulObjectProps) => void,
    setEnnemy?: (e: EnnemyDto) => void
}

export const SoulTracker = (props: MinorEnnemyTrackerProps) => {


    let [ennemy, setEnnemy] = useState<EnnemyDto | null>(null)
    let [dungeon, setDungeon] = useState<string>("")

    if(isNil(props.track))
        return <></>
    // let deku = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("Deku"))
    // let dc = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("DC"))
    // let jabu = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("Jabu"))
    // let forest = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("Forest"))
    // let fire = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("Fire"))
    // let water = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("Water"))
    // let spirit = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("Spirit"))
    // let shadow = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("Shadow"))
    // let gtg = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("GTG"))
    // let ice = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("Ice"))
    // let botw = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("BotW"))
    // let ganon = UsefullEnnemySoul.filter(x => x.dungeonsMandatory?.includes("Ganon"))

    let ennemies = isNil(props.ennemies) ? orderBy(UsefullEnnemySoul, "name") : props.ennemies;

    return <Box display="flex" width="450px" flexDirection={"column"} flexWrap={"wrap"}>
   
   <Box display="flex" justifyContent={"center"} fontSize={20}>{props.track === "boss" ? "Boss " : props.track === "regional" ? "Regional " : ""} Soul Tracker</Box>
   <Box display="flex" justifyContent={"center"} fontSize={20} height={20}>{ennemy?.name} {!isNil(ennemy) && "(" + ennemy?.dungeonsMandatory?.join(", ")+ ")"}</Box>
 

    <Box display="flex" flexWrap={"wrap"} width="400px" justifyContent={"flex-start"} alignItems={"flex-start"}>
        {props.track === "all" && ennemies.filter(x => x.type === "monster").map((e) => {
            return <Box display="flex" margin="5px" className={e.dungeonsMandatory?.includes(dungeon) ? "soul-dungeon" : "inherit"}>
                <SoulTrackingItem ennemy={e} setName={setEnnemy} setEnnemyObtain={(v) => {if(!isNil(props.setEnnemy)) props.setEnnemy({...e, isObtained: v})}} />
            </Box>
        })}
        <Box width={"100%"}></Box>
        {!isNil(props.track) && props.track !== "regional" && ennemies.filter(x => x.type === "boss").map((e) => {
            return <Box display="flex" margin="5px">
                <SoulTrackingItem ennemy={e}  setName={setEnnemy} setEnnemyObtain={(v) => {if(!isNil(props.setEnnemy)) props.setEnnemy({...e, isObtained: v})}}/>
            </Box>
        })}
        {props.track === "regional" && <Box display="flex" margin="5px" flexWrap={"wrap"}>
           
            <RegionalSoulObject label={"Deku"} 
                {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Deku)} 
                setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Deku, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Deku), isObtain: v})}}
                />
            <RegionalSoulObject label={"DC"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.DC)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.DC, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.DC), isObtain: v})}}/>
            <RegionalSoulObject label={"Jabu"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Jabu)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Jabu, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Jabu), isObtain: v})}}/>
            <Box width={"100%"} />
            <RegionalSoulObject label={"Forest"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Forest)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Forest, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Forest), isObtain: v})}}/>
            <RegionalSoulObject label={"Fire"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Fire)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Fire, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Fire), isObtain: v})}}/>
            <RegionalSoulObject label={"Water"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Water)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Water, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Water), isObtain: v})}}/>
            <RegionalSoulObject label={"Shadow"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Shadow)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Shadow, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Shadow), isObtain: v})}}/>
            <RegionalSoulObject label={"Spirit"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Spirit)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Spirit, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Spirit), isObtain: v})}}/>
            <RegionalSoulObject label={"Ganon"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Ganon)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Ganon, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Ganon), isObtain: v})}}/>
            <Box width={"100%"} />
            <RegionalSoulObject label={"Botw"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Botw)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Botw, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Botw), isObtain: v})}}/>
            <RegionalSoulObject label={"ICE"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Ice)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Ice, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Ice), isObtain: v})}}/>
            <RegionalSoulObject label={"GTG"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Gtg)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Gtg, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Gtg), isObtain: v})}}/>
            <Box width={"100%"} />
            <RegionalSoulObject label={"SFM"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.SFM)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.SFM, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.SFM), isObtain: v})}}/>
            <RegionalSoulObject label={"Grottos"} {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Grottos)} setIsObtain={(v) => {if(!isNil(props.setRegionalEnnemy) && !isNil(props.regionalEnnemies)) props.setRegionalEnnemy(RegionSoulEnum.Grottos, {...props.regionalEnnemies?.find(x => x.region === RegionSoulEnum.Grottos), isObtain: v})}}/>
        </Box>}
        {props.track === "all" && <Box display={"flex"}>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "Deku") setDungeon(""); else setDungeon("Deku");}}><SimpleKokiriEmeraldItem /></Box>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "DC") setDungeon(""); else setDungeon("DC");}}><SimpleGoronRubyItem /></Box>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "Jabu") setDungeon(""); else setDungeon("Jabu");}}><SimpleZoraSapphireItem /></Box>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "Forest") setDungeon(""); else setDungeon("Forest");}}><SimpleForestMedallionItem /></Box>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "Fire") setDungeon(""); else setDungeon("Fire");}}><SimpleFireMedallionItem /></Box>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "Water") setDungeon(""); else setDungeon("Water");}}><SimpleWaterMedallionItem /></Box>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "Shadow") setDungeon(""); else setDungeon("Shadow");}}><SimpleShadowMedallionItem /></Box>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "Spirit") setDungeon(""); else setDungeon("Spirit");}}><SimpleSpiritMedallionItem /></Box>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "Ganon") setDungeon(""); else setDungeon("Ganon");}}>Ganon</Box>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "GTG") setDungeon(""); else setDungeon("GTG");}}>GTG</Box>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "Ice") setDungeon(""); else setDungeon("Ice");}}>ICE</Box>
            <Box display={"flex"} marginRight={"2px"} alignItems={"center"} onClick={(e) => {e.preventDefault(); if(dungeon === "BotW") setDungeon(""); else setDungeon("BotW");}}>BOTW</Box>
        </Box>}

    </Box>
    {props.displayDungeonData && <>
    {/* <Box display="flex" justifyContent={"center"} fontSize={20} width={"100%"} textAlign={"center"}>Dungeon Soul Required (check or progression)</Box>
    <Box display="flex" flexDirection={"column"} flexWrap={"wrap"} height="550px">
        
        <SoulRequirementLine boss={GhomaSoul} data={deku} location="Deku" />
        <SoulRequirementLine boss={KdSoul} data={dc} location="DC" />
        <SoulRequirementLine boss={BarinadeSoul} data={jabu} location="Jabu" />
        <SoulRequirementLine boss={PgSoul} data={forest} location="Forest" />
        <SoulRequirementLine boss={VolvagiaSoul} data={fire} location="Fire" />
        <SoulRequirementLine boss={MorphaSoul} data={water} location="Water" />
        <SoulRequirementLine boss={BongoSoul} data={shadow} location="Shadow" />
        <SoulRequirementLine boss={TwinrovaSoul} data={spirit} location="Spirit" />
        <SoulRequirementLine data={gtg} location="GTG" />
        <SoulRequirementLine data={ice} location="Ice" />
        <SoulRequirementLine data={botw} location="BotW" />
        <SoulRequirementLine data={ganon} location="Ganon" />
    </Box> */}
    </>}
</Box>
}

interface SoulTrackingItemProps {
    ennemy: EnnemyDto
    setName: (v: EnnemyDto | null) => void,
    setEnnemyObtain?: (v: boolean) => void
}

const SoulTrackingItem = (props: SoulTrackingItemProps ) => {
    return <Box position={"relative"} display="flex" margin="3px" flexDirection={"column"} textAlign={"center"} >
        <Box  onMouseOver={() => {props.setName(props.ennemy)}} onMouseLeave={() => {props.setName(null)}}><Item id={props.ennemy.name} image={props.ennemy.img} title={props.ennemy.name} isObtained={props.ennemy.isObtained} setIsObtained={props.setEnnemyObtain}/></Box>
    </Box>
}

// interface SoulRequirementLineProps {
//     data: Array<EnnemyDto>
//     boss?: EnnemyDto,
//     location: string
// }

// const SoulRequirementLine = (props: SoulRequirementLineProps) => {

//     let imgSize = 70;
//     let fontSize = 16;
//     return  <Box key={props.location} display={"flex"}>
//         <Box width={imgSize} fontSize={20} alignItems={"center"} display={"flex"} marginRight={2}>{props.location}</Box>
//          {!isNil(props.boss) && <Box marginRight={2} display={"flex"} flexDirection={"column"} justifyContent={"center"} textAlign={"center"} fontSize={fontSize}><img alt={"boss"} src={props.boss.img} width={imgSize} height={imgSize}/>{props.boss.name}</Box>}
//          {props.data.map(i => { return <Box width={imgSize} marginRight={2} display={"flex"} flexDirection={"column"} justifyContent={"center"} textAlign={"center"} fontSize={fontSize}><img src={i.img}  width={imgSize} height={imgSize} alt={i.name}/>{i.name}</Box>})}
//     </Box>
// }


export interface RegionalSoulObjectProps {
    label?: string,
    img?: string,
    isObtain?: boolean,
    setIsObtain?: (v: boolean) => void,
    region?: RegionSoulEnum
}

const RegionalSoulObject = (props: RegionalSoulObjectProps) => {

    
    let [isLocalObtain, setIsLocalObtain] = useState<boolean>(false)

    let isObtain = !isNil(props.isObtain) ? props.isObtain : isLocalObtain;
    let setIsObtain = !isNil(props.setIsObtain) ? props.setIsObtain : setIsLocalObtain;

    const onDrag = (e: DragEvent<HTMLDivElement>) => {
        e.dataTransfer.setData("text/plain", JSON.stringify({img: props.img ?? "", name: props.label, altString: props.label} as OotItemDto))
    }


    return <Box onDragOver={(e) => { e.preventDefault(); }} onDragEnter={(e) => { e.preventDefault(); }}>
        <Box sx={{filter: isObtain ? "inherit" : "brightness(0.6)"}} textAlign={"center"} width={65} marginRight={1} marginBottom={2}  onClick={() => {console.log(props, isObtain); setIsObtain(!isObtain)}} >
        {!isNil(props.img) ? <img draggable src="" alt={props.label} onDragStart={onDrag} /> : <Box component={Typography} draggable onDragStart={onDrag} sx={{boxShadow: !isObtain ? "inherit" : "0px 0px 10px rgba(58,86,169,1)"}} border={!isObtain ? "inherit" :"blue solid 1px"}>{props.label}</Box>}
    </Box>
    </Box>
}